import React from 'react';
import GoogleMapReact from 'google-map-react';
import { MdLocationPin } from 'react-icons/md';

export default function GoogleMap() {
  const lang = window.location.href.includes('/fr') ? 'fr' : 'eng';

  const defaultProps = {
    center: {
      lat: 25.12017126087601,
      lng: 55.380084421495454
    },
    zoom: 12,
    minZoom: 12,
    maxZoom: 12
  };

  return (
    // Important! Always set the container height explicitly
    <div className="google-map-style-1">
      <div style={{ height: '100%', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: 'AIzaSyAm8VKTYs2ADQj4PtZyrPx-ZkcptFNQ-a0',
            language: lang === 'fr' ? 'fr' : 'en'
          }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        >
          <MdLocationPin
            style={{
              height: '40px',
              width: '40px',
              color: 'red',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
            lat={25.12017126087601}
            lng={55.380084421495454}
          />
        </GoogleMapReact>
      </div>
    </div>
  );
}
